import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//router
import { BrowserRouter } from "react-router-dom";
//store
import { Provider } from "react-redux";
//reducer
import Store from "./store";

import { Auth0Provider } from "@auth0/auth0-react";
import { AUTH0_AUDIENCE } from "./helpers/authToken";

ReactDOM.render(
  // <React.StrictMode>
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <Provider store={Store}>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        // OJO: `audience` va DENTRO de `authorizationParams`, no como prop de nivel
        // superior. `auth0-spa-js` 2.0.4 declara `audience` en el type de
        // Auth0ClientOptions pero NUNCA lo lee: al pedir el token arma el request con
        // `this.options.authorizationParams.audience || 'default'`. Con el prop
        // arriba, el SDK mandaba audience='default', Auth0 devolvia un token de la
        // Management API (System API de machine-to-machine, cifrada con `alg: dir`
        // usando el client secret) y el backend lo rechazaba con 401 en todas las
        // llamadas. Es API de v3, no de v2.
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: AUTH0_AUDIENCE
        }}
      >
        <App />
      </Auth0Provider>
    </Provider>
  </BrowserRouter>,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
